module.exports = __webpack_public_path__ + "img/logo.3531bf92.png";